import Link from "next/link";
import { ArticleItemProps } from "./constants";
import MinArticle from "./MinArticle";
import HorizontalArticle from "./HorizontalArticle";


interface CategorizedArticleProps {
  articles: Array<ArticleItemProps>;
  tittle: string | null;
  link: string | null;
  limit?: boolean;
}

const CategorizedArticle = (props: CategorizedArticleProps) => {
  const { articles, tittle, link, limit } = props

  return (
    <div className="font-poppins">
      {tittle !== null && tittle && (
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-base font-bold text-black md:text-xl">{tittle}</h3>
          {link !== null && link.length > 0 && (
            <div>
              <Link href={link}>
                <a className="text-xs text-black underline">Xem tất cả</a>
              </Link>
            </div>
          )}
        </div>
      )}
      <div className="md:hidden">
        <MinArticle article={articles[0]} option="A" />
        {limit ? (
          <div className="pt-4 space-y-4">
            {articles.slice(1, 5).map((article, index) => (
              <HorizontalArticle key={index} article={article} animated={true} />
            ))}
          </div>
        ) : (
          <div className="pt-4 space-y-4">
            {articles.slice(1).map((article, index) => (
              <HorizontalArticle key={index} article={article} animated={true} />
            ))}
          </div>
        )}
      </div>
      <div className="hidden md:block">
        {limit ? (
          <div className="grid grid-cols-2 gap-6">
            {articles.slice(0, 4).map((article, index) => (
              <MinArticle key={index} article={article} option="B" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-6">
            {articles.map((article, index) => (
              <MinArticle key={index} article={article} option="B" />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default CategorizedArticle
